import script from "./OrganizationGeneralDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationGeneralDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationGeneralDocuments.vue?vue&type=style&index=0&id=c2db1202&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2db1202"]])

export default __exports__